/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import * as React from "react";
import Card from "./cardv2";

type ErrorFallbackCardProps = {
  error: {
    message: string;
  };
};

function ErrorFallbackCard({
  error,
}: ErrorFallbackCardProps): React.ReactElement {
  return (
    <Card title="Error" testId="error-boundary">
      <div role="alert">{error.message}</div>
    </Card>
  );
}

export default ErrorFallbackCard;
